/**
 * Enterprise Lesson Registry — loads lesson definitions by ID.
 */
import type { EnterpriseLessonDef } from '@graphicsim/shared-types';
import { entGfx01 } from './ent-gfx-01';
import { entGfx02 } from './ent-gfx-02';
import { entGfx03 } from './ent-gfx-03';
import { entGfx04 } from './ent-gfx-04';
import { entGfx05 } from './ent-gfx-05';

const lessons: Record<string, EnterpriseLessonDef> = {
  'ent-gfx-01': entGfx01,
  'ent-gfx-02': entGfx02,
  'ent-gfx-03': entGfx03,
  'ent-gfx-04': entGfx04,
  'ent-gfx-05': entGfx05,
};

export function getEnterpriseLesson(id: string): EnterpriseLessonDef | undefined {
  return lessons[id];
}

export function getAllEnterpriseLessonIds(): string[] {
  return Object.keys(lessons);
}
